import { UseFormReturn } from 'react-hook-form';

import { SafeParseError } from 'zod';

import { ActionStateErrors, InputData, RHFErrorsLike } from './type';

// react-hook-form 7.60+ introduced a third generic `TTransformedValues` on
// `UseFormReturn`. Callers using `useForm()` get it inferred as the generic
// `TFieldValues`, which doesn't structurally match `T` here. We don't use
// `handleSubmit`/`watch` typed values inside this helper (only `setError`),
// so widening the third generic to `any` is safe and avoids forcing every
// caller to specify it.
export function setFormErrors<T extends InputData>(
  errors: ActionStateErrors<T>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<T, any, any>,
) {
  Object.entries(errors).forEach(([path, message]) => {
    // We cannot say to Typescript that path is already typed to keyof T + root
    form.setError(path as RHFErrorsLike<T>, {
      message,
    });
  });
}

export function mapZodErrorsToActionFormErrors<T extends InputData>(
  zodErrors: SafeParseError<T>,
  fieldsToPassAsRoot?: Array<keyof Partial<T>>,
): ActionStateErrors<T> {
  return zodErrors.error.issues.reduce((errors, issue) => {
    const key = issue.path.join('.');
    const keyPassed = fieldsToPassAsRoot?.includes(key) ? 'root' : key;
    return {
      ...errors,
      [keyPassed]: issue.message,
    };
  }, {});
}
